import i18n from 'i18n';
import { COLORS } from 'modules/core/theme/colors';

import { IBadge } from './Badge';

export const VEHICLE_STATUS_BADGE_PROPS: Record<string, IBadge> = {
  NEW: {
    title: i18n.t('components.table.cellsTitles.new'),
    color: COLORS.ORANGE_2,
  },
  JUST_ARRIVED: {
    title: i18n.t('components.table.cellsTitles.justArrived'),
    color: COLORS.BLUE_11,
  },
  PENDING_SALE: {
    title: i18n.t('components.table.cellsTitles.pendingSale'),
    color: COLORS.BLUE_5,
  },
  MAKE_IT_WORK: {
    title: i18n.t('components.table.cellsTitles.makeItWork'),
    color: COLORS.WHITE,
    textColor: COLORS.GREEN_9,
    borderColor: COLORS.GREEN_8,
  },
};
